export class DixperRunnerSimple {
  constructor(interactor, configuration) {
    this.interactor = interactor;
    this.configuration = configuration;
    this.isDefaultOn = false;
  }

  onData(heartRate) {
    let range = this.findRange(heartRate);
    if (this.interactor.isConnected()) {
      if (
        range != null &&
        (this.currentRange == null || this.currentRange !== range)
      ) {
        this.currentRange = range;
        this.interactor.launchSkill(range.skill);
      } else if (this.currentRange !== range) {
        this.currentRange = null;
      }
    }
  }

  findRange(heartRate) {
    for (const range of this.configuration.ranges) {
      if (range.from <= heartRate && range.to > heartRate) {
        return range;
      }
    }
    return null;
  }
}
